module.exports = __webpack_public_path__ + "public/img/download_btn.png";